export const TipoStatus = {

  ATIVO: 'A' as 'A',
  INATIVO: 'I' as 'I',
  TODOS: 'T' as 'T'

}

